module.exports = __webpack_public_path__ + "static/media/scotland.9f9a1d05.jpg";